import { render, staticRenderFns } from "./EnumValue.vue?vue&type=template&id=2b631559"
import script from "./EnumValue.vue?vue&type=script&lang=js"
export * from "./EnumValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports